import React from 'react';
import { Menu } from 'antd';

const isExternalUrl = (value) => /^https?:\/\//.test(String(value));

const ExternalLink = ({ href, children, onClose }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClose}>
    {children}
  </a>
);

function ArchiveDropdown({ archives, onClose }) {
  const safeArchives = Array.isArray(archives) ? archives : [];

  return (
    <Menu.SubMenu title="Archive" key="/archive">
      {safeArchives.map((archive) => {
        const year = String(archive?.year ?? '');
        const label = String(archive?.label ?? `WCHSS ${year}`);
        const links = archive?.links || {};
        const mainLink = String(links?.main ?? '');
        const publicationLink = String(links?.publication ?? '');
        const galleryLink = String(links?.gallery ?? '');

        return (
          <Menu.SubMenu title={label} key={`/archive/${year}`}>
            <Menu.Item key={mainLink}>
              {isExternalUrl(mainLink) ? (
                <ExternalLink href={mainLink} onClose={onClose}>{`Go to WCHSS ${year}`}</ExternalLink>
              ) : (
                `Go to WCHSS ${year}`
              )}
            </Menu.Item>

            <Menu.Item key={publicationLink}>
              {isExternalUrl(publicationLink) ? (
                <ExternalLink href={publicationLink} onClose={onClose}>Publication</ExternalLink>
              ) : (
                'Publication'
              )}
            </Menu.Item>

            <Menu.Item key={galleryLink}>Gallery</Menu.Item>
          </Menu.SubMenu>
        );
      })}
    </Menu.SubMenu>
  );
}

export default ArchiveDropdown;
